(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "677ce971823fdcd5020279e2";
              window.beaePageSetting.pageTitle = "Build by Beae dev"; 
              window.beaePageSetting.pageType = "page";

          let js_2MA4DFJI = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-7nu2o04psection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7nu2o04p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7nu2o04p');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}}else if(n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7nu2o04p: ', ex)
      };
    

      try {
        let argid = 'beae-7nu2o04psection-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7nu2o04p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7nu2o04p');
        args.el = args.els[0];
        ((data
) => { const pageScrollItems = data.el.querySelectorAll('.pageScrollItem');
let isMoving = false;
let currentIndex = 0;
const viewportHeight = window.innerHeight;
const beaeBuilder = document.querySelector("#beae-builder");
const wdw = window.innerWidth;

if(data.el){
  document.body.style.overflow = 'hidden';
    if(!beaeBuilder){
      let style = document.createElement("style");
      style.innerHTML = `body::-webkit-scrollbar { display: none; }`;
      document.head.appendChild(style);
    } 
}
if (beaeBuilder) {
    data.el.setAttribute('beae-app', 'true');
}
const image = data.el.querySelector('.beae-image-video')
if(image) {
  const video = data.el.querySelector('video');
  image.style.height = video.clientHeight + 'px';
}
function updateStyles(newIndex) {
    pageScrollItems.forEach((item, index) => { 
        if (index < newIndex) { 
          if (beaeBuilder) {
            item.style.transform = `translate3d(0px, -${viewportHeight}px, 0px)`;
          }else{
            if (wdw >= 768) {
                item.style.transform = `translate3d(0px, -${viewportHeight - 90}px, 0px)`;
            } else {
                item.style.transform = `translate3d(0px, -${viewportHeight - 84}px, 0px)`;
            }
          }

          item.style.zIndex = pageScrollItems.length - index;
        } else if (index === newIndex) { 
            item.style.transform = `translate3d(0px, 0px, 0px)`;
            item.style.zIndex = pageScrollItems.length - index;
            item.classList.add('active');
        } else {
            if (newIndex === 0 && index === 1) {
                item.style.transform = `translate3d(0px, 0px, 0px)`;
            } else {
                if (beaeBuilder) {
                    item.style.transform = `translate3d(0px, ${viewportHeight / 2 }px, 0px)`;
                }else{
                  if (wdw >= 768) {
                    item.style.transform = `translate3d(0px, ${viewportHeight / 2 - 45}px, 0px)`;
                  } else {
                    item.style.transform = `translate3d(0px, ${viewportHeight / 2 - 37}px, 0px)`;
                  }
                }

                

            }
            item.style.zIndex = pageScrollItems.length - index;
        }

        if (index !== newIndex) {
            item.classList.remove('active');
        }
    });

    if (newIndex === 0) {
        data.el.classList.add('class-first-page');
    } else {
        data.el.classList.remove('class-first-page');
    }
}

function onScroll(event) {
    if (isMoving) return;

    const direction = event.deltaY > 0 ? 1 : -1;
    const newIndex = currentIndex + direction;

   if (newIndex < 0 || newIndex >= pageScrollItems.length) {

    if (currentIndex === pageScrollItems.length - 1 && direction === 1) {
    
      document.body.style.overflow = 'auto';
      window.removeEventListener('wheel', onScroll);
    }
    return;
  }
    isMoving = true;
    currentIndex = newIndex;

    updateStyles(currentIndex);

    data.el.classList.add('is-moving');

    setTimeout(() => {
        data.el.classList.remove('is-moving');
        isMoving = false;
    }, 1300);
}
 
 window.addEventListener('scroll', () => {
    if (!data.el) return; 

    const rect = data.el.getBoundingClientRect();
    const isAtBottom = rect.bottom >= window.innerHeight;
 if (isAtBottom){
  window.addEventListener('wheel', onScroll);
  document.body.style.overflow = 'hidden';
 }else{
    window.removeEventListener('wheel', onScroll);
    document.body.style.overflow = 'auto';
 } 
}); 


window.addEventListener('wheel', onScroll);
updateStyles(currentIndex);
data.el.classList.add('class-first-page'); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7nu2o04p: ', ex)
      };
    

      try {
        let argid = 'beae-87tkw6wxblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-87tkw6wx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-87tkw6wx');
        args.el = args.els[0];
        ((T) => { if(T.el){let H=T.el.querySelector(".beae-image-content-position"),z,I=T.autoHover;var N=H.querySelector(".beae-img-ratio-control"),E=H.querySelector(".beae-img-comp-container"),O=H.querySelector(".beae-img-comp-container--second");if(N&&O){let P=function(A){let D=0,q,j;R(),I?H.onmouseover=function(K){W(K)}:A.onmousedown=function(K){W(K)},H.onmouseup=function(){F()},A.ontouchstart=function(K){W(K)},H.ontouchend=function(){F()};function R(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),A.style.left&&(q=parseInt(A.style.left))}function W(K){check=!1,K.preventDefault(),K.clientX?K.clientX:K.touches[0].clientX,q=parseInt(A.style.left),D=1,H.onmousemove=function(te){G(te)},H.ontouchmove=function(te){G(te)}}function F(){D=0,isNaN(j)||(q=j),check=!0}function G(K){if(D==0)return!1;j=Z(K),j<0&&(j=0),j>100&&(j=100),J(j)}function Z(K){const te=H.getBoundingClientRect(),le=K.changedTouches?K.changedTouches[0].clientX:K.clientX,oe=le-te.left;let re;return I?re=Math.round(oe*100/z):re=Math.round(q-(le-K.pageX)*100/z),re}function J(K){A.style.left=K+"%",O.style.clipPath=`polygon(${K}% 0%, ${K}% 100%, 100% 100%, 100% 0)`,E.style.clipPath=`polygon(0% 100%, 0% 0%, ${K}% 0%, ${K}% 100%)`}};N&&O&&P(N),window.addEventListener("resize",function(){N&&O&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),P(N))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-87tkw6wx: ', ex)
      };
    

      try {
        let argid = 'beae-lkznxgjyblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lkznxgjy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lkznxgjy');
        args.el = args.els[0];
        ((T) => { if(T.el){let H=T.el.querySelector(".beae-image-content-position"),z,I=T.autoHover;var N=H.querySelector(".beae-img-ratio-control"),E=H.querySelector(".beae-img-comp-container"),O=H.querySelector(".beae-img-comp-container--second");if(N&&O){let P=function(A){let D=0,q,j;R(),I?H.onmouseover=function(K){W(K)}:A.onmousedown=function(K){W(K)},H.onmouseup=function(){F()},A.ontouchstart=function(K){W(K)},H.ontouchend=function(){F()};function R(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),A.style.left&&(q=parseInt(A.style.left))}function W(K){check=!1,K.preventDefault(),K.clientX?K.clientX:K.touches[0].clientX,q=parseInt(A.style.left),D=1,H.onmousemove=function(te){G(te)},H.ontouchmove=function(te){G(te)}}function F(){D=0,isNaN(j)||(q=j),check=!0}function G(K){if(D==0)return!1;j=Z(K),j<0&&(j=0),j>100&&(j=100),J(j)}function Z(K){const te=H.getBoundingClientRect(),le=K.changedTouches?K.changedTouches[0].clientX:K.clientX,oe=le-te.left;let re;return I?re=Math.round(oe*100/z):re=Math.round(q-(le-K.pageX)*100/z),re}function J(K){A.style.left=K+"%",O.style.clipPath=`polygon(${K}% 0%, ${K}% 100%, 100% 100%, 100% 0)`,E.style.clipPath=`polygon(0% 100%, 0% 0%, ${K}% 0%, ${K}% 100%)`}};N&&O&&P(N),window.addEventListener("resize",function(){N&&O&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),P(N))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lkznxgjy: ', ex)
      };
    

      try {
        let argid = 'beae-lkp2ir08button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lkp2ir08',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lkp2ir08');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate?n=data.el.querySelector(".beae-content-size-chart-preview"):(window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault()),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(l=>{l.isIntersecting&&(o.unobserve(l.target),l.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lkp2ir08: ', ex)
      };
    

      try {
        let argid = 'beae-bqrdvzulblock-video',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bqrdvzul',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bqrdvzul');
        args.el = args.els[0];
        ((data) => { if(data.mode.value==="builder")return;data.source=="self hosted"&&data.el.querySelector(".beae_video")&&data.mute&&(data.el.querySelector(".beae_video").muted="muted");const playButton=data.el.querySelector(".beae-video_overlay-icon"),playIcon=playButton&&playButton.querySelector(".beae-video-icon-play"),closePlayingButton=data.el.querySelector(".beae-close-video"),closeVideoFn=()=>{let u=playButton.closest(".beae-grid-block"),_=data.el.querySelector(".beae-x-video--wrapper");_&&_.classList.remove("playing"),u&&(u.style.zIndex=""),data.lightbox&&(document.querySelector("div.beae-builder")&&(document.querySelector("div.beae-builder").style.zIndex=""),u&&u.setAttribute("style",""),document.body.style.overflow="",document.documentElement.style.overflow="");let p=data.el.querySelector(".beae_video");p&&(p.autoplay=!1,p.pause());let x=data.el.querySelector(".beae_iframe");x&&x.getAttribute("src").indexOf("&autoplay=1")>-1&&x.setAttribute("src",x.getAttribute("src").replace("&autoplay=1",""))};if(playButton&&(playIcon&&playIcon.addEventListener("click",e=>{if(data.source=="self hosted"){let u=data.el.querySelector(".beae_video");u.autoplay=!0,u.load(),playButton.classList.remove("beae-overlay"),data.play_icon&&(data.el.querySelector(".beae-video-icon-play").style.display="none")}else{let u=data.el.querySelector(".beae_iframe"),_=u.getAttribute("src")+"&autoplay=1";u.setAttribute("src",_),playButton.classList.remove("beae-overlay"),data.play_icon&&(data.el.querySelector(".beae-video-icon-play").style.display="none")}let gridBlock=playButton.closest(".beae-grid-block"),wrapper=data.el.querySelector(".beae-x-video--wrapper");if(wrapper&&wrapper.classList.add("playing"),gridBlock&&(gridBlock.style.zIndex=1e8),data.lightbox){let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(u){extOptions={},console.error(u)}window.BeaePopupLibrary.createPopup(data.el.querySelector(".beae-block_video-player"),{width:"1070px",sectionId:data.id,...extOptions}),closeVideoFn()}}),closePlayingButton&&closePlayingButton.addEventListener("click",closeVideoFn)),["youtube","vimeo"].includes(data.source)&&(data.autoplay||data.loop)){let u=data.el.querySelector(".beae_iframe"),_={isloop:data.loop,autoplay:data.autoplay,idBlock:data.id,controls:data.player_controls?1:0};if(data.source=="youtube"){const p=/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;let x=data.srcYoutube.match(p),g=x&&x[2].length===11?x[2]:null;const v=/[?&]t=(\d+)s/,$=data.srcYoutube.match(v),S=$?$[1]:0;_.start=S,_.id=g,_.src=location.protocol+"//www.youtube.com/embed/"+g}switch(data.source){case"youtube":setTimeout(()=>{window.BEAEVIDEO.handleLoopYoutube&&window.BEAEVIDEO.handleLoopYoutube(_,data.id)});break;case"vimeo":setTimeout(()=>{window.BEAEVIDEO.handleLoopVimeo&&window.BEAEVIDEO.handleLoopVimeo(_,u)});break}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bqrdvzul: ', ex)
      };
    

      try {
        let argid = 'beae-amh512zkblock-video',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-amh512zk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-amh512zk');
        args.el = args.els[0];
        ((data) => { if(data.mode.value==="builder")return;data.source=="self hosted"&&data.el.querySelector(".beae_video")&&data.mute&&(data.el.querySelector(".beae_video").muted="muted");const playButton=data.el.querySelector(".beae-video_overlay-icon"),playIcon=playButton&&playButton.querySelector(".beae-video-icon-play"),closePlayingButton=data.el.querySelector(".beae-close-video"),closeVideoFn=()=>{let u=playButton.closest(".beae-grid-block"),_=data.el.querySelector(".beae-x-video--wrapper");_&&_.classList.remove("playing"),u&&(u.style.zIndex=""),data.lightbox&&(document.querySelector("div.beae-builder")&&(document.querySelector("div.beae-builder").style.zIndex=""),u&&u.setAttribute("style",""),document.body.style.overflow="",document.documentElement.style.overflow="");let p=data.el.querySelector(".beae_video");p&&(p.autoplay=!1,p.pause());let x=data.el.querySelector(".beae_iframe");x&&x.getAttribute("src").indexOf("&autoplay=1")>-1&&x.setAttribute("src",x.getAttribute("src").replace("&autoplay=1",""))};if(playButton&&(playIcon&&playIcon.addEventListener("click",e=>{if(data.source=="self hosted"){let u=data.el.querySelector(".beae_video");u.autoplay=!0,u.load(),playButton.classList.remove("beae-overlay"),data.play_icon&&(data.el.querySelector(".beae-video-icon-play").style.display="none")}else{let u=data.el.querySelector(".beae_iframe"),_=u.getAttribute("src")+"&autoplay=1";u.setAttribute("src",_),playButton.classList.remove("beae-overlay"),data.play_icon&&(data.el.querySelector(".beae-video-icon-play").style.display="none")}let gridBlock=playButton.closest(".beae-grid-block"),wrapper=data.el.querySelector(".beae-x-video--wrapper");if(wrapper&&wrapper.classList.add("playing"),gridBlock&&(gridBlock.style.zIndex=1e8),data.lightbox){let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(u){extOptions={},console.error(u)}window.BeaePopupLibrary.createPopup(data.el.querySelector(".beae-block_video-player"),{width:"1070px",sectionId:data.id,...extOptions}),closeVideoFn()}}),closePlayingButton&&closePlayingButton.addEventListener("click",closeVideoFn)),["youtube","vimeo"].includes(data.source)&&(data.autoplay||data.loop)){let u=data.el.querySelector(".beae_iframe"),_={isloop:data.loop,autoplay:data.autoplay,idBlock:data.id,controls:data.player_controls?1:0};if(data.source=="youtube"){const p=/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;let x=data.srcYoutube.match(p),g=x&&x[2].length===11?x[2]:null;const v=/[?&]t=(\d+)s/,$=data.srcYoutube.match(v),S=$?$[1]:0;_.start=S,_.id=g,_.src=location.protocol+"//www.youtube.com/embed/"+g}switch(data.source){case"youtube":setTimeout(()=>{window.BEAEVIDEO.handleLoopYoutube&&window.BEAEVIDEO.handleLoopYoutube(_,data.id)});break;case"vimeo":setTimeout(()=>{window.BEAEVIDEO.handleLoopVimeo&&window.BEAEVIDEO.handleLoopVimeo(_,u)});break}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-amh512zk: ', ex)
      };
    }; if (window.BEAEBASE) {js_2MA4DFJI()} else {window.BEAEPAGEJS.push(js_2MA4DFJI)} })(); 